<template>
  <span>
    <a
      style="cursor: pointer;"
      @click="show()"
    >
      <feather-icon style="margin-left: 5px;" icon="InfoIcon" size="14" stroke-width="3" class="text-primary" />
    </a>

    <b-modal
      ref="modalInfo"
      ok-only
      ok-title="OK"
      centered
      size="lg"
      hide-header
    >
      <div class="text-center mb-2">
        <b-avatar
          variant="light-warning"
          size="60"
          class="mb-1"
        >
          <feather-icon icon="AlertCircleIcon" size="28" />
        </b-avatar>
        <h4 class="font-weight-bold">
          <feather-icon icon="FileTextIcon" class="mr-50" />
          Informações sobre configuração da tela!
        </h4>
      </div>

      <div class="mb-2">
        <h6 class="font-weight-bold">
          <feather-icon icon="InfoIcon" size="13" class="mr-25" /> Informações sobre o envio automático
        </h6>
        <p class="mb-50">
          O envio automático de documentos pode ser configurado para todas as empresas ou apenas para um <strong>grupo específico</strong> de empresas.
        </p>
        <p class="font-weight-bold mb-25">
          <feather-icon icon="SearchIcon" size="13" class="mr-25" /> Seleção de empresas
        </p>
        <p class="mb-0">
          Para definir o envio apenas para algumas empresas, utilize o <strong>Filtro Avançado</strong> e selecione as empresas desejadas.
        </p>
        <p>
          Caso <strong>nenhuma empresa</strong> seja selecionada, o sistema considerará automaticamente todas as empresas cadastradas em sua base de dados.
        </p>
      </div>

      <div class="mb-2">
        <h6 class="font-weight-bold">
          <feather-icon icon="CheckSquareIcon" size="13" class="mr-25" /> Condições para que o envio ocorra
        </h6>
        <p class="mb-25">
          No momento da execução do envio, o sistema enviará o documento apenas para empresas que atenderem aos seguintes critérios:
        </p>
        <ul class="mb-0 pl-1">
          <li>Possuam <strong>e-mail cadastrado</strong></li>
          <li>Possuam <strong>{{ condicaoDocumento }}</strong></li>
          <li>Atendam às configurações definidas nesta tela</li>
        </ul>
      </div>

      <div class="mb-2">
        <h6 class="font-weight-bold">
          <feather-icon icon="SettingsIcon" size="13" class="mr-25" /> Opção „Não enviar„
        </h6>
        <p class="mb-0">
          Ao selecionar a opção <strong>„Não enviar„</strong>, todos os demais campos da configuração serão automaticamente desabilitados, impedindo a definição de regras de envio.
        </p>
      </div>

      <div class="mb-2">
        <h6 class="font-weight-bold">
          <feather-icon icon="ZapIcon" size="13" class="mr-25" /> Boas práticas
        </h6>
        <p class="mb-25">
          Para maior controle do envio automático, recomenda-se:
        </p>
        <ul class="mb-0 pl-1">
          <li>Definir grupos de empresas utilizando o Filtro Avançado</li>
          <li>Verificar se os e-mails das empresas estão atualizados</li>
          <li>Confirmar se as empresas possuem {{ monitoramentoTexto }}</li>
        </ul>
      </div>

      <p class="text-center font-weight-bold mt-2 mb-0">
        Atenciosamente, Equipe Monitor Contábil
      </p>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'ModalInfoEnvioAutomatico',
  props: {
    condicaoDocumento: {
      type: String,
      default: 'CND com status Regular',
    },
    monitoramentoTexto: {
      type: String,
      default: 'monitoramento ativo de CND',
    },
  },
  methods: {
    show() {
      this.$refs.modalInfo.show()
    },
  },
}
</script>
